// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2e0Mf","errorLogs":"EditorFooter_errorLogs__22WXC"};